import { LocalizedPack } from 'apollo/localizedTypes';
import { FormFields, Options } from 'components/UI/Form/types';
import requiredDefaultLanguage from 'utils/i18n/requiredDefaultLanguage';
import isEmptyRichText from 'utils/i18n/isEmptyRichText';
import toFormLocalizedText from 'utils/i18n/toFormLocalizedText';
import { ReactNode } from 'react';
import * as featureTexts from 'assets/texts/ticketFeatures';

const packFormFields = (
  isCreation: boolean,
  entranceTicketTypesOptions: Options | undefined,
  activitiesOptions: Options | undefined,
  editableRow?: LocalizedPack,
  uploadelement?: ReactNode
): FormFields[] => {
  const formFields = [
    {
      name: 'name',
      label: 'Tipo de Ticket',
      type: 'localizedText',
      initialValue: editableRow?.name,
      rules: [requiredDefaultLanguage('Campo requerido')],
    },
    {
      name: 'adultValue',
      label: 'Precio ticket adultos',
      type: 'number',
      initialValue: editableRow?.adultValue,
      rules: [
        {
          required: isCreation,
          type: 'number' as const,
          min: 0,
          transform: (value: unknown) => Number(value),
        },
      ],
    },
    {
      name: 'otherValue',
      label: 'Precio adulto mayor o niños',
      type: 'number',
      initialValue: editableRow?.otherValue,
      rules: [
        {
          required: isCreation,
          type: 'number' as const,
          min: 0,
          transform: (value: unknown) => Number(value),
        },
      ],
    },
    {
      name: 'description',
      label: 'Descripción',
      type: 'localizedTextarea',
      initialValue: toFormLocalizedText(editableRow?.description || undefined),
      rules: isCreation
        ? [requiredDefaultLanguage('Campo requerido', isEmptyRichText)]
        : [],
    },
    {
      name: 'entranceTicketTypes',
      label: 'Tipos de entrada',
      type: 'select',
      initialValue:
        editableRow?.entranceTicketTypes.map((entranceTicket) => {
          return {
            label: entranceTicket.name.es || '',
            value: Number(entranceTicket.id),
          };
        }) || [],
      options: entranceTicketTypesOptions,
      rules: [{ required: isCreation }],
      mode: 'multiple' as const,
    },
    {
      name: 'activities',
      label: 'Actividades',
      type: 'select',
      initialValue:
        editableRow?.activities.map((activity) => {
          return {
            label: activity.name?.toString() || '',
            value: Number(activity.id),
          };
        }) || [],
      options: activitiesOptions,
      rules: [{ required: isCreation }],
      mode: 'multiple' as const,
    },
    {
      name: 'features',
      label: featureTexts.title,
      type: 'ticketFeatures',
      initialValue: editableRow?.features || [],
      rules: [{ required: false }],
    },
  ];

  if (isCreation) {
    return formFields;
  }

  return [
    ...formFields,
    {
      name: 'images',
      label: 'Fotos',
      type: 'images',
      uploadelement,
      rules: [{ required: false }],
    },
  ];
};

export default packFormFields;
